import Api from '../services/Api';
import { ConsultaProdutosRequest } from '../shared/types/importacaoXML';

class ImportacaoXMLController {
  public static async consultarProdutos(
    request: ConsultaProdutosRequest
  ): Promise<any> {
    try {
      const response = await Api.post(
        `api/ImportacaoXml/ConsultarProdutos`,
        request
      );
      return response?.data;
    } catch (error: any) {
      return [];
    }
  }

  public static async salvarXml(request: any): Promise<any> {
    try {
      console.log("CHEGUEI AQUI")
      console.log(request)
      const response = await Api.post(`api/ImportacaoXml/SalvarXML`, {
        XMLJson: JSON.stringify(request),
      });
      return {
        success: true,
        response,
      };
    } catch (error: any) {
      return {
        success: false,
        message:
          error?.response?.data?.ErroDetalhado ??
          'Houve um error ao cadastrar a XML!',
      };
    }
  }

  public static async consultarNfEntrada(request: any): Promise<any> {
    try {
      const queryString = new URLSearchParams(request).toString();
      const response = await Api.get(
        `api/ImportacaoXml/ListarNfEntrada?${queryString}`
      );
      return response?.data;
    } catch (error: any) {
      return [];
    }
  }

  // Verifica se a NF ja foi importada, para avisar na hora de importar o XML
  // (antes o aviso vinha do Salvar, no fim do preenchimento).
  public static async verificarNfImportada(numeroNf: number): Promise<any> {
    try {
      const { data } = await Api.get(
        `api/ImportacaoXml/VerificarNfImportada/${numeroNf}`
      );
      return data;
    } catch (error: any) {
      // Em caso de falha na consulta nao bloqueia a importacao: o Salvar ainda valida.
      return { jaImportada: false, notas: [] };
    }
  }

  public static async consultarNfEntradaUnico(nfId: number): Promise<any> {
    try {
      const { data } = await Api.get(`api/ImportacaoXml/GetNFEntrada/${nfId}`);
      return data;
    } catch (error: any) {
      return {};
    }
  }

  public static async finalizarNfEntrada(nfId: number): Promise<boolean> {
    try {
      await Api.post(
        `api/ImportacaoXml/finalizarNfEntrada/${nfId}`
      );
      return true;
    } catch (error: any) {
      return false;
    }
  }

  /**
   * Exclui logicamente a importação.
   *
   * Devolve o erro DETALHADO, e não um booleano, porque aqui a mensagem é a resposta: a
   * procedure recusa nota finalizada e nota com devolução registrada dizendo o motivo, e
   * no segundo caso lista quais devoluções travam. Engolir isso num `false` deixaria o
   * operador com um "não deu" e nada para fazer com ele.
   */
  public static async excluirNfEntrada(
    nfId: number
  ): Promise<{ ok: boolean; dados?: any; erro?: string }> {
    try {
      const response = await Api.post(`api/ImportacaoXml/excluirNFEntrada/${nfId}`);
      return { ok: true, dados: response?.data };
    } catch (error: any) {
      return {
        ok: false,
        erro:
          error?.response?.data?.ErroDetalhado ??
          error?.response?.data?.Erro ??
          'Não foi possível excluir esta importação.',
      };
    }
  }
}

export default ImportacaoXMLController;
